import { render, staticRenderFns } from "./access-denied.vue?vue&type=template&id=51a7663a"
var script = {}
import style0 from "./access-denied.vue?vue&type=style&index=0&id=51a7663a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports